﻿import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {browserHistory} from 'react-router';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { renderTextField, renderSelectField } from '../../components/core/editors';
import NavigationBack from 'material-ui/svg-icons/navigation/arrow-back';
import {Paper, FlatButton, IconButton, AppBar, CircularProgress, LinearProgress, MenuItem} from 'material-ui';
import service from '../../services/template-services';

class TemplateSend extends Component {
    constructor(props, context) {
        super(props, context);

        this.onBackToList = this.onBackToList.bind(this);
        this.submitForm = this.submitForm.bind(this);

        this.templateId = context.router.params.templateId;
    }

    componentWillMount() {
        this.props.onGet(this.templateId);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    notifyFormError() {
        this.setState({error: data})
    }

    submitForm(data) {
        this.props.onSend(data);
    }

    onBackToList() {
        browserHistory.goBack();
    }

    render() {

        const { handleSubmit, pristine, submitting, inProgress, saving, dataObject } = this.props;

        if (inProgress) {
            return (
                <div>
                    <AppBar title="Send Message" iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}/>
                    <CircularProgress size={100} thickness={5}/>
                </div>
            )
        }

        var subject;
        if(!dataObject){
            return (
                <div>
                    <AppBar title="Send Message" iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}/>
                    <p>Template not found</p>
                </div>
            )
        } else {
            subject = dataObject.Subject;
        }

        return (
            <div>
                <form onSubmit={handleSubmit(this.submitForm)} noValidate={true} >
                    <AppBar title="Send Message"
                            iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}
                            iconElementRight={<FlatButton label="Send" type="submit" disabled={pristine || submitting}/>}
                            />

                    <Paper className="template-edit-form" zDepth={1}>
                        { saving ? <LinearProgress mode="indeterminate"/> : null }

                        <Field type="hidden" name="Id" value={dataObject.Id} component={renderTextField}/>
                        <Field name="Subject" hintText="Subject" floatingLabelText="Subject" component={renderTextField} value={subject} required/>
                        <br/>
                        <Field name="Reporters" hintText="Reporters (separate by comma)" floatingLabelText="Reporters (separate by comma)" component={renderTextField} required/>
                        <br/>
                        <Field name="SendCopyTo" hintText="Send copy to (separate by comma)" floatingLabelText="Send copy to (separate by comma)" component={renderTextField}/>
                        <br/>
                        <Field name="Type" value="Email" floatingLabelText="Send Type" component={renderSelectField}>
                            <MenuItem value="Email" primaryText="Send Email" />
                            <MenuItem value="Alert" primaryText="Send Alert" />
                            <MenuItem value="Screen" primaryText="Screen Message" />
                        </Field>
                        <br/>
                        <div>
                            <Field name="FromStart" hintText="From" floatingLabelText="From" required component={renderTextField}/>
                            <Field name="FromEnd" value="@breakingnewsnetwork.com" hintText="Domain" floatingLabelText="Domain" component={renderSelectField}>
                                <MenuItem value="@breakingnewsnetwork.com" label="@breakingnewsnetwork.com" primaryText="@breakingnewsnetwork.com" />
                                <MenuItem value="@bnn.us" label="@bnn.us" primaryText="@bnn.us" />
                                <MenuItem value="@newslinked.com" label="@newslinked.com" primaryText="@newslinked.com" />
                            </Field>
                        </div>
                    </Paper>
                </form>
            </div>
        );
    }
}

TemplateSend.contextTypes = {
    router: PropTypes.any.isRequired
};

const mapStateToProps = state => ({...state.templates});

const mapDispatchToProps = dispatch => ({
    onGet: (id) =>
        dispatch({type: 'REQUEST_TEMPLATE', payload: id > 0 ? service.TemplateServices.getTemplate(id) : {
            Id: 0,
            Name: '',
            Source: ''
        }}),
    onSend: (data) =>
        dispatch({type: 'SEND_TEMPLATE', payload: service.TemplateServices.sendTemplate(data)}),
    onUnload: () =>
        dispatch({type: 'TEMPLATE_PAGE_UNLOADED'})
});

const validate = values => {
    const errors = {};
    const requiredFields = [ 'RoleName', 'CountiesAllowed' ];
    requiredFields.forEach(field => {
        if (!values[ field ] && values[field] !== 0) {
            errors[ field ] = 'Required';
        }
    });
    if (isNaN(Number(values.CountiesAllowed))) {
        errors.CountiesAllowed = 'Must be a number'
    } else if (Number(values.CountiesAllowed) < 0) {
        errors.CountiesAllowed = 'Sorry, value must be positive'
    }
    return errors;
};

TemplateSend = reduxForm({
    form: 'templateEditForm',
    enableReinitialize: true,
    validate
})(TemplateSend);

TemplateSend = connect(mapStateToProps, mapDispatchToProps)(TemplateSend);

export default TemplateSend;